import { TermsInfo } from '../../data-types/initialisation/initialisationInterfaces';
import { AcceptedCountries, AvailableLanguage } from '../../data-types/international/internationalEnums';
import { UserQuestionsTypes } from '../../data-types/user/userEnums';
import { ProofRequest, User, UserAchievement } from '../../data-types/user/userInterfaces';
import { ResetState } from './stateTypes';

export type UserDataActionType =
  | ResetState
  | SetLocale
  | SetAuthenticationAction
  | SetUserDetails
  | SetTermsInfo
  | ClearUserDetails
  | SetUserLocation
  | SetGeoLocationInfo
  | SetInboxBadge
  | SetProofRequests
  | SetSelectedProofRequest
  | SetPendingQuestions
  | SetUserAchievement
  | SetUserAchievementsUpdated
  | SetLoadingAchievements
  | SetSaferGamblingQuestionsSet;

export const SET_LOCALE = 'SET_LOCALE';
export const SET_AUTHENTICATION = 'SET_AUTHENTICATION';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_TERMS_INFO = 'SET_TERMS_INFO';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_GEO_LOCATION = 'SET_GEO_LOCATION';
export const SET_INBOX_BADGE = 'SET_INBOX_BADGE';
export const SET_PROOF_REQUESTS = 'SET_PROOF_REQUESTS';
export const SET_SELECTED_PROOF_REQUEST = 'SET_SELECTED_PROOF_REQUESTS';
export const SET_PENDING_QUESTIONS = 'SET_PENDING_QUESTIONS';
export const SET_USER_ACHIEVEMENTS = 'SET_USER_ACHIEVEMENTS';
export const SET_USER_ACHIEVEMENTS_UPDATED = 'SET_USER_ACHIEVEMENTS_UPDATED';
export const SET_LOADING_ACHIEVEMENTS = 'SET_LOADING_ACHIEVEMENTS';
export const SET_SAFER_GAMBLING_QUESTIONS_SET = 'SET_SAFER_GAMBLING_QUESTIONS_SET';

export interface UserDataState {
  locale: AvailableLanguage | undefined;
  userLocation: AcceptedCountries | undefined;
  geoLocation: string | undefined;
  authentication: number;
  user: undefined | User;
  terms: TermsInfo;
  inboxBadge: number;
  proofRequests: ProofRequest[];
  selectedProofRequest: ProofRequest | undefined;
  pendingQuestions: boolean;
  achievements: UserAchievement[];
  achievementsUpdated: boolean;
  loadingAchievements: boolean;
  saferGamblingQuestionsSet: UserQuestionsTypes | undefined;
}

interface SetLocale {
  type: typeof SET_LOCALE;
  meta: AvailableLanguage | undefined;
}

interface SetAuthenticationAction {
  type: typeof SET_AUTHENTICATION;
  meta: {
    authentication: number;
  };
}

interface SetUserDetails {
  type: typeof SET_USER_DETAILS;
  meta: User;
}

interface ClearUserDetails {
  type: typeof CLEAR_USER_DETAILS;
  meta: undefined;
}

interface SetTermsInfo {
  type: typeof SET_TERMS_INFO;
  meta: TermsInfo;
}

interface SetUserLocation {
  type: typeof SET_USER_LOCATION;
  meta: AcceptedCountries | undefined;
}

interface SetGeoLocationInfo {
  type: typeof SET_GEO_LOCATION;
  meta: string | undefined;
}

interface SetInboxBadge {
  type: typeof SET_INBOX_BADGE;
  meta: number;
}

interface SetProofRequests {
  type: typeof SET_PROOF_REQUESTS;
  meta: ProofRequest[];
}

interface SetSelectedProofRequest {
  type: typeof SET_SELECTED_PROOF_REQUEST;
  meta: ProofRequest;
}

interface SetPendingQuestions {
  type: typeof SET_PENDING_QUESTIONS;
  meta: boolean;
}

interface SetUserAchievement {
  type: typeof SET_USER_ACHIEVEMENTS;
  meta: UserAchievement[];
}

interface SetUserAchievementsUpdated {
  type: typeof SET_USER_ACHIEVEMENTS_UPDATED;
  meta: boolean;
}

interface SetLoadingAchievements {
  type: typeof SET_LOADING_ACHIEVEMENTS;
  meta: boolean;
}

interface SetSaferGamblingQuestionsSet {
  type: typeof SET_SAFER_GAMBLING_QUESTIONS_SET;
  meta: UserQuestionsTypes | undefined;
}
